import { Injectable } from '@angular/core';
import lottie from 'lottie-web/build/player/lottie_light';

@Injectable({
  providedIn: 'root',
})
export class LottieService {
  constructor() {}

  get player() {
    return lottie;
  }
}
